<template>
    <div class="settings-wrapper">
        <div class="settings-content">
            <div class="settings-grid">
                <label for="pumpedStorage">
                    Pumped hydro storage
                    <info-icon-with-tooltip direction="top" tooltip-text="By default we exclude pumped hydro storage from our figures as it often dwarfs the deployment new storage technologies. Toggle this switch to include pumped hydro in the data." />
                </label>
                <div class="row">
                    <select-button
                        id="pumpedStorage"
                        :allow-empty="false"
                        :model-value="showPumpedHydro"
                        :options="showPumpedHydroOptions"
                        @update:model-value="updatePumpedHydro"
                        option-label="name"
                        option-value="id"
                    />
                </div>
                <template v-if="isAdmin">
                    <label for="animateYears">
                        Animate years
                    </label>
                    <div class="row">
                        <select-button
                            id="animateYears"
                            :allow-empty="false"
                            :model-value="animateYears"
                            :options="animateYearsOptions"
                            @update:model-value="updateYears"
                            option-label="name"
                            option-value="id"
                        />
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue';
import { useAllDataStore } from '@/stores/storageTracking/AllDataStore.ts';
import { useFilterDataStore } from '@/stores/storageTracking/FilterDataStore.ts';
import { useUserAccessStore } from '@/stores/userAccessStore.ts';
import SelectButton from 'primevue/selectbutton';
import { IIdNameBoolean } from '@/interfaces/general/IIdName.ts';
import InfoIconWithTooltip from '@/components/common/InfoIconWithTooltip.vue';

const allDataStore = useAllDataStore();
const filterDataStore = useFilterDataStore();
const userStore = useUserAccessStore();

const animateYearsOptions: Array<IIdNameBoolean> = [
    { id: true, name: 'Animate' },
    { id: false, name: 'Static' },
];

const showPumpedHydroOptions: Array<IIdNameBoolean> = [
    { id: true, name: 'Include' },
    { id: false, name: 'Exclude' },
];

const animateYears = ref<boolean>(false);
const showPumpedHydro = ref<boolean>(false);

const isAdmin = computed(() => userStore.hasAccess(userStore.storageTrackingConfig) && userStore.storageTrackingConfig.isAdmin);

function updateYears (newSetting: boolean): void {
    allDataStore.updateAnimateYears(newSetting);
}

function updatePumpedHydro (newSetting: boolean): void {
    allDataStore.updateUsePumpedStorage(newSetting);
}

function initialise (): void {
    animateYears.value = allDataStore.animateYears;
    showPumpedHydro.value = filterDataStore.usePumpedStorage;
}

initialise();
</script>

<style lang="scss" scoped>
.settings-wrapper {
    display: grid;
    grid-template-rows: auto 1fr;
    height: 100%;
    overflow: hidden;

    .settings-content {
        overflow-y: auto;
        padding: var(--defaultSpacing);
    }
}
.settings-grid {
    align-items: center;
    display: grid;
    gap: var(--defaultSpacing) var(--largeSpacing);
    grid-template-columns: auto 1fr;
}
.row {
    display: flex;
    gap: 10px;
    align-items: center;
    font-size: var(--smallFontSize);
}
</style>
